const spacing = (size = 1) => {
    return `${8 * size}px`;
  };
  
  export default spacing;
  